// Single truth for "is this a dev seed, not a real client".
// Lives in shared/ because BOTH the staff matrix (worker/src/staff.ts) and the
// daily queue (worker/src/staff-queue.ts) must answer it identically - a queue
// that shows tenants the client list hides sends the partner to a client that
// does not exist in their world.
export function isTestTenant(name: string, email: string, override?: boolean | null): boolean {
  // Explicit false is just as meaningful as true. Null keeps old tenants
  // on the historical heuristic until an admin classifies them.
  if (typeof override === "boolean") return override;
  const normalizedEmail = email.trim().toLowerCase();
  const emailDomain = normalizedEmail.split("@").at(-1);
  // Dev seeds: example.cz, +lptest aliases, wave/module codenames (M1-M9,
  // W1-W9), english pilots and annotation accounts. Real clients never carry
  // a bare module prefix like "M6 " in their display name.
  return Boolean(emailDomain?.startsWith("example."))
    || Boolean(emailDomain?.endsWith(".invalid"))
    || normalizedEmail.includes("+lptest")
    || /smoke|demo|test|anotace|english|launchpad/i.test(name)
    || /^[mw]\d+\b/i.test(name.trim());
}
